'use strict';

//Fetch module (defined in app.js)
angular.module('App.v1.Services')

	//******************** SERVICES *****************************************************************
	.factory('App.v1.Services.OutboundMessage', ['$resource', '$filter',
		function ($resource, $filter) {
			return $resource(
				'/api/message/:id',
				{},
				{
					'send': { method: 'POST', url: '/api/message/send', isArray: false }
				}
			);
		}]);
